import { EditFieldBase } from './edit-field-base.model';
import { EditFieldControlTypeEnum } from './edit-field-control-type.enum.model';

export class EditFieldDate extends EditFieldBase<Date> {
    controlType = EditFieldControlTypeEnum.Date;
}
